<template>
  <LinkdeConviteEventNew
    v-if="isShow"
    :shareInfo="shareInfo"
  ></LinkdeConviteEventNew>
  <LinkdeConviteEvent v-else></LinkdeConviteEvent>
</template>

<script>
import { shareIndex } from '@/apis/modules/share.js';
import LinkdeConviteEvent from './LinkdeConviteEvent.vue';
import LinkdeConviteEventNew from './LinkdeConviteEvent_New.vue';
export default {
  props: {},
  components: {
    LinkdeConviteEvent,
    LinkdeConviteEventNew
  },
  data() {
    return {
      isShow: false,
      shareInfo: {}
    };
  },
  mounted() {
    shareIndex({
      activity: 0
    }).then(({ data }) => {
      this.shareInfo = data;
      this.isShow = data.user_invite;
    });
  },
  methods: {}
};
</script>
<style scoped></style>
